import { render, staticRenderFns } from "./TemplateModulo.vue?vue&type=template&id=6384c3ea"
import script from "./TemplateModulo.vue?vue&type=script&lang=js"
export * from "./TemplateModulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports